export const GET_ALL_TEAM_MEMBER = 'GET_ALL_TEAM_MEMBER';
export const GET_ALL_TEAM_MEMBER_SUCCESS = 'GET_ALL_TEAM_MEMBER_SUCCESS';
export const GET_ALL_TEAM_MEMBER_ERROR = 'GET_ALL_TEAM_MEMBER_ERROR';
export const ORDER_TEAM_MEMBER = 'ORDER_TEAM_MEMBER';
export const ORDER_TEAM_MEMBER_SUCCESS = 'ORDER_TEAM_MEMBER_SUCCESS';
export const ORDER_TEAM_MEMBER_ERROR = 'ORDER_TEAM_MEMBER_ERROR';
export const CREATE_TEAM_MEMBER = 'CREATE_TEAM_MEMBER';
export const CREATE_TEAM_MEMBER_SUCCESS = 'CREATE_TEAM_MEMBER_SUCCESS';
export const CREATE_TEAM_MEMBER_ERROR = 'CREATE_TEAM_MEMBER_ERROR';
export const UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER';
export const UPDATE_TEAM_MEMBER_SUCCESS = 'UPDATE_TEAM_MEMBER_SUCCESS';
export const UPDATE_TEAM_MEMBER_ERROR = 'UPDATE_TEAM_MEMBER_ERROR';
export const CHANGE_TEAM_MEMBER = 'CHANGE_TEAM_MEMBER';
export const CHANGE_TEAM_MEMBER_SUCCESS = 'CHANGE_TEAM_MEMBER_SUCCESS';
export const CHANGE_TEAM_MEMBER_ERROR = 'CHANGE_TEAM_MEMBER_ERROR';
export const DELETE_TEAM_MEMBER = 'DELETE_TEAM_MEMBER';
export const DELETE_TEAM_MEMBER_SUCCESS = 'DELETE_TEAM_MEMBER_SUCCESS';
export const DELETE_TEAM_MEMBER_ERROR = 'DELETE_TEAM_MEMBER_ERROR';
